function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#A94EF1",
    fillRule: "evenodd",
    d: "M3.454 4.5h16.577l-2.175 13.526-5.416-1.044-2.404 2.648-1.178-2.693H4.542L3.454 4.5Zm1.091 1 .913 10.437h4.054l.822 1.878 1.744-1.922 4.954.956L18.857 5.5H4.545Zm9.788 4.389H8.111v-1h6.222v1Zm0 1.555H8.111v-1h6.222v1ZM11.222 13H8.11v-1h3.11v1Z",
    clipRule: "evenodd",
    style: {
      fill: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComments);
export default __webpack_public_path__ + "static/media/icon_comments.7a558321767695d7e6bb431249ff527d.svg";
export { ForwardRef as ReactComponent };